import React from 'react';
import { useNavigate } from 'react-router-dom';
import SharedModal from './SharedModal/SharedModal';

interface ConfigureTimezoneModalProps {
  visible: boolean;
  onCancel: () => void;
}

export const ConfigureTimezoneModal: React.FC<ConfigureTimezoneModalProps> = ({ visible, onCancel }) => {
  const navigate = useNavigate();

  const handleGoToSettings = () => {
    onCancel();
    navigate('/profile?tab=settings');
  };

  return (
    <SharedModal
      open={visible}
      onClose={onCancel}
      title="Configure timezone"
      size="sm"
      footer={
        <>
          <button type="button" className="shared-modal__btn shared-modal__btn--secondary" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="shared-modal__btn shared-modal__btn--primary" onClick={handleGoToSettings}>
            Go to Settings
          </button>
        </>
      }
    >
      <p className="shared-modal__text">
        Set your timezone in Profile → Settings. Sends and the allowed time window use that value only — not your
        computer&apos;s clock or region.
      </p>
    </SharedModal>
  );
};

export default ConfigureTimezoneModal;
